
import DesktopSubArticle from "@/components/child/product/DesktopSubArticle";

export default {
    props: {
        topNum: {
            type: Number
        },
        bar_length: {
            type: Array
        },
        product_ranking_data: {
            type: Array
        },
        top_product_article_data: {
            type: Array
        },
        productDataApiTop: {
            type: Object
        },
        showAnimation: {
            type: Boolean
        }
    },
    data() {
        return {}
    },
    components: {
        DesktopSubArticle
    },
    methods: {
        openDetail(dataIndex) {
            const vm = this;
            vm.$emit("openDetail", dataIndex);
        }
    }
}
